import { createContext, useContext } from 'react'

import type { ColorMode, FontPreference } from '../../lib/muiTheme'

// Re-export so consumers can import everything from this module
export type { ColorMode, FontPreference }

type ThemeContextValue = {
  mode: ColorMode
  setMode: (mode: ColorMode) => void
  fontPreference: FontPreference
  setFontPreference: (font: FontPreference) => void
  bionicReading: boolean
  setBionicReading: (enabled: boolean) => void
}

export const ThemeContext = createContext<ThemeContextValue>({
  mode: 'light',
  setMode: () => undefined,
  fontPreference: 'default',
  setFontPreference: () => undefined,
  bionicReading: false,
  setBionicReading: () => undefined,
})

export const useThemePreferences = () => useContext(ThemeContext)
